import { AssetDTO } from "src/app/shared/models/models";


export class eventpageDetails {
  pageTitle:string = '';
  conferencesSectionTitle:string = '';
  conferencesSectionIcon: AssetDTO= new AssetDTO();
  aboutConferences:string = '';
  coursesSectionTitle:string = '';
  coursesSectionIcon: AssetDTO= new AssetDTO();
  aboutCourses:string = '';
  seminarsSectionTitle:string = '';
  seminarsSectionIcon: AssetDTO= new AssetDTO();
  aboutSeminars:string = '';
  hideConferencesSection:string = '';
  hideCoursesSection:string = '';
  hideSeminarsSection:string = '';
}

export class eventpageModel {
  flatData: eventpageDetails = new eventpageDetails();
}